import { Grid } from '@mui/material';
import Button from '../Button';
import colors from '../../theme/colors';
import brokenLink from '../assets/brokenLink.svg';
import * as T from '../Typography';

const InvalidToken = ({ title, subtitle, btnLabel, onBtnClick }) => {
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid
        container
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ width: { xs: '100%', sm: '584px' } }}
      >
        <img src={brokenLink} alt="token invalid" />
        <T.TextLargeBold
          mt="6"
          mb="2"
          ta="center"
          color={colors.neutral.shades.shade700}
        >
          {title}
        </T.TextLargeBold>
        <T.TextSmallRegular
          ta="center"
          center
          color={colors.neutral.shades.shade600}
        >
          {subtitle}
        </T.TextSmallRegular>
        <Grid
          item
          mt={2}
          margin={'auto'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          {btnLabel && (
            <Button
              type="button"
              variant="primary"
              width={'fit-content'}
              mt={5}
              handleClick={onBtnClick}
            >
              {btnLabel}
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InvalidToken;
